import { render, staticRenderFns } from "./P2PCertificates.vue?vue&type=template&id=138f045b&scoped=true"
import script from "./P2PCertificates.vue?vue&type=script&lang=js"
export * from "./P2PCertificates.vue?vue&type=script&lang=js"
import style0 from "./P2PCertificates.vue?vue&type=style&index=0&id=138f045b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f045b",
  null
  
)

export default component.exports